import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { manageGroupsDialogInit, manageGroupsDialogCreateNewGroup } from './actions'

function mapStateToProps(state) {
    return {
        loading: state.getIn(['ui', 'manageGroups', 'loading']),
        groups: state.getIn(['ui', 'entityStack', 'groups', 'groups']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            manageGroupsDialogInit,
            manageGroupsDialogCreateNewGroup,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
